/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_Create_FirstInputs */

const en_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first listing`)
};

const es_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu primer anuncio`)
};

const fr_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre première annonce`)
};

const de_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle dein erstes Inserat`)
};

const ja_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初めての出品を作成する`)
};

const zh_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建您的第一个商品`)
};

const ar_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بإنشاء إعلانك الأول`)
};

const id_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat listing pertama Anda`)
};

const it_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il tuo primo annuncio`)
};

const ru_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте первое объявление`)
};

const pt_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie o seu primeiro anúncio`)
};

const ko_seller_listings_create_first = /** @type {(inputs: Seller_Listings_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 번째 상품을 등록해 보세요`)
};

/**
* | output |
* | --- |
* | "Create your first listing" |
*
* @param {Seller_Listings_Create_FirstInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_create_first = /** @type {((inputs?: Seller_Listings_Create_FirstInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_Create_FirstInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_create_first(inputs)
	if (locale === "es") return es_seller_listings_create_first(inputs)
	if (locale === "fr") return fr_seller_listings_create_first(inputs)
	if (locale === "de") return de_seller_listings_create_first(inputs)
	if (locale === "ja") return ja_seller_listings_create_first(inputs)
	if (locale === "zh") return zh_seller_listings_create_first(inputs)
	if (locale === "ar") return ar_seller_listings_create_first(inputs)
	if (locale === "id") return id_seller_listings_create_first(inputs)
	if (locale === "it") return it_seller_listings_create_first(inputs)
	if (locale === "ru") return ru_seller_listings_create_first(inputs)
	if (locale === "pt") return pt_seller_listings_create_first(inputs)
	return ko_seller_listings_create_first(inputs)
});